import { logger } from '../../../utils/logger';
import type { TransferSkill } from '../types';
import { acdApiGet, extractArrayFromResponse } from './acd-api.util';

function mapSkillItem(item: unknown): TransferSkill {
  const skill = item as {
    skillId?: string | number;
    SkillId?: string | number;
    skillName?: string;
    SkillName?: string;
    isActive?: boolean;
    IsActive?: boolean;
    mediaTypeName?: string;
    MediaTypeName?: string;
    maxSecondsACW?: number;
    MaxSecondsACW?: number;
    acwTypeId?: number;
    AcwTypeId?: number;
    requireDisposition?: boolean;
    RequireDisposition?: boolean;
    isOutbound?: boolean;
    IsOutbound?: boolean;
    outboundStrategy?: string;
    OutboundStrategy?: string;
  };

  return {
    skillId: String(skill.skillId || skill.SkillId || ''),
    skillName: skill.skillName || skill.SkillName || 'Unknown Skill',
    isActive: skill.isActive ?? skill.IsActive ?? true,
    mediaType: skill.mediaTypeName || skill.MediaTypeName || undefined,
    maxSecondsACW: skill.maxSecondsACW ?? skill.MaxSecondsACW ?? 0,
    acwTypeId: skill.acwTypeId ?? skill.AcwTypeId,
    requireDisposition: skill.requireDisposition ?? skill.RequireDisposition,
    isOutbound: skill.isOutbound ?? skill.IsOutbound ?? false,
    outboundStrategy: skill.outboundStrategy || skill.OutboundStrategy,
  };
}

export async function getSkillsList(): Promise<TransferSkill[]> {
  logger.debug('[CXone SDK] Getting skills list...');

  try {
    const data = await acdApiGet('/InContactAPI/services/v23.0/skills', 'getSkillsList');
    if (!data) {
      return [];
    }

    const skills = extractArrayFromResponse(data, ['skills', 'Skills']);
    const activeSkills = skills.map(mapSkillItem).filter((skill) => skill.isActive);

    logger.debug('[CXone SDK] Mapped skills:', activeSkills);
    return activeSkills;
  } catch (error) {
    logger.error('[CXone SDK] getSkillsList failed:', error);
    return [];
  }
}
